<template>
  <el-form ref="form" :model="user" :rules="formRules" label-width="90px">
    <el-form-item label="旧密码" prop="oldPassword">
      <el-input v-model="user.oldPassword" placeholder="请输入旧密码" type="password" show-password/>
    </el-form-item>
    <el-form-item label="新密码" prop="newPassword" :rules="infoPwdValidator">
      <el-input v-model="user.newPassword" placeholder="请输入新密码" type="password" show-password/>
    </el-form-item>
    <el-form-item label="确认密码" prop="confirmPassword">
      <el-input v-model="user.confirmPassword" placeholder="请确认新密码" type="password" show-password/>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" size="mini" @click="submit">保存</el-button>
      <el-button type="danger" size="mini" @click="close">关闭</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { updateUserPassword } from "@/api/system/user"
import passwordRule from "@/utils/passwordRule"

export default {
  mixins: [passwordRule],
  data() {
    return {
      user: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
    }
  },
  computed: {
    formRules() {
      return {
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (this.user.newPassword !== value) {
                callback(new Error("两次输入的密码不一致"))
              } else {
                callback()
              }
            }, trigger: "blur"
          }
        ]
      }
    }
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          updateUserPassword(this.user).then(res => {
            if (res.flag) {
              this.user.oldPassword = "";
              this.user.newPassword = "";
              this.user.confirmPassword = "";
              this.$modal.msgSuccess("修改成功")
            }else {
              this.$modal.msgError(res.msg);
            }

          })
        }
      })
    },
    close() {
      this.$tab.closePage()
    }
  }
}
</script>
